<bw-action-card-legacy 
  (ctaClicked)="showChatInterface()" 
  [cardConfig]="chatActionCardConfig">
</bw-action-card-legacy>
